import { Injectable } from '@angular/core';
import { CommonUtilty } from '../../utilities';
import { ErrorDO } from 'app/BaseFramework/shared/models/error.model';

@Injectable({
  providedIn: 'root'
})
export class ClientHandlingService {

  constructor(private commonUtility: CommonUtilty) { }

  baseClientDONode: string = "clientDOs";
  transactionClientListDONames = ['PolicyClientDO', 'CaseClientDO', 'ClaimClientDO'];

  extractClientNode(DO) {
    let clientNode = null;
    switch (DO) {
      case 'proposalDO':
        clientNode = 'proposalClients';
        break;
      case 'caseDO':
        clientNode = 'caseClients';
        break;
      case 'claimDO':
        clientNode = 'claimClientList';
        break;

      default:
        break;
    }
    return clientNode;
  }

  clientRoleDataMap = {};

  createClientRoleMap(payload: Object, DO: string, LOB: string) {

    let clientNode = this.extractClientNode(DO);

    if (payload && this.commonUtility.isArrayIterable(payload[this.baseClientDONode])
      && payload[DO] && this.commonUtility.isArrayIterable(payload[DO][clientNode])) {

      payload[DO][clientNode].forEach(clientObj => {
        let clientDO = payload[this.baseClientDONode].find(item => item.guid == clientObj.clientRefGuid);
        if (clientDO) {
          let tempCLientMapObj = {
            "clientDOData": { ...clientDO },
            "flattenData": {
              "flattenClientDOData": this.flattenObject(clientDO),
              "transactionClientData": { ...clientObj }
            }
          }
          if (Array.isArray(this.clientRoleDataMap[clientObj.roleCd])) {
            this.clientRoleDataMap[clientObj.roleCd].push({ ...tempCLientMapObj });
          } else {
            this.clientRoleDataMap[clientObj.roleCd] = [tempCLientMapObj];
          }
        }
      });

    }
  }

  /**This will flatten without path, only returns all the nested attributes at flatten level**/
  flattenObject(obj) {
    const result = {};

    function recurse(currentObj) {
      for (const key in currentObj) {
        if (!currentObj.hasOwnProperty(key)) continue;

        const value = currentObj[key];

        if (Array.isArray(value)) {
          result[key] = value;
        } else if (typeof value === 'object' && value !== null) {
          recurse(value);
        } else if (result[key]) {
          // This is done as personDO data is being overwritten by clientDO data. For ex: dateOfBirth attribute is at clientDO level and at personDO level.
        } else {
          result[key] = value;
        }
      }
    }

    recurse(obj);

    return result;
  }

  updateClientDataToPayload(payload, DO) {
    let clientNode = this.extractClientNode(DO);

    if (!payload || !payload[DO]) return payload;

    payload[this.baseClientDONode] = [];
    payload[DO][clientNode] = [];

    if (Object.keys(this.clientRoleDataMap).length > 0) {
      for (const clientRole in this.clientRoleDataMap) {
        if (this.commonUtility.isArrayIterable(this.clientRoleDataMap[clientRole])) {
          this.clientRoleDataMap[clientRole].forEach(clientObj => {
            payload[this.baseClientDONode] = this.commonUtility.uniquePushInArray(payload[this.baseClientDONode], clientObj['clientDOData'], 'guid');
            payload[DO][clientNode].push({ ...clientObj['flattenData']['transactionClientData'] });
          });
        }
      }
    }

    return payload;
  }

  checkSplitPercentage(array, keyToCompare) {
    let total = array.reduce((sum, obj) => {
      if (obj && obj['flattenData'] && obj['flattenData']['transactionClientData']) {
        let splitPercentage = Number(obj['flattenData']['transactionClientData'][keyToCompare]) || 0;
        if (isNaN(splitPercentage)) {
          throw new Error("Invalid  value detected to check for Split percentage");
        }
        return sum + splitPercentage;
      }
    }, 0);

    // Check if the total is 100
    if (total !== 100) {
      let errorDO = new ErrorDO();
      errorDO.errorMsg = "Total of Split Percentages should be 100.";
      errorDO.componentName = null;
      errorDO.fieldName = "Split Percentage";
      errorDO.fieldNameDescription = "Split Percentage"
      return [errorDO];
    }
    return [];
  }

  clearClientRoleMap() {
    this.clientRoleDataMap = {};
  }

}
